export const PROPERTY_TYPES = [
  'Apartment',
  'Duplex',
  'Triplex',
  'Villa',
  'Chalet',
  'Shop',
  'Office',
  'Retail',
  'Showroom',
  'Warehouse',
  'Building',
  'Land',
  'Restaurants',
];
